export const RUN_AI_PROCESS_TAG_FIELDS = [
  { key: 'completedTagId', testIdKey: 'completed-tag', label: 'When the run completes' },
  {
    key: 'awaitingConfirmationTagId',
    testIdKey: 'awaiting-confirmation-tag',
    label: 'When it waits for confirmation',
  },
  { key: 'failedTagId', testIdKey: 'failed-tag', label: 'When it fails' },
];

export const RUN_AI_PROCESS_TAGS_TITLE = 'Add a tag to the loan';

export const RERUN_ON_TRIGGER_LABEL = 'Run again each time the trigger matches';
